import {Injectable} from '@angular/core';
import {LoanApplicationPipelineStage} from '../../model/LoanApplicationTransition';

export const ProgressMilestones = {
    ApplicationSubmission: {
        order: 1,
        pendingLabel: 'Application Submission',
        completedLabel: 'Application Submitted'
    }, KycVerification: {
        order: 2,
        pendingLabel: 'KYC Verification',
        completedLabel: 'KYC Verified',
    }, OfferAcceptance: {
        order: 3,
        pendingLabel: 'Accept Offer',
        completedLabel: 'Offer Accepted',
    }, LoanFulfilment: {
        order: 4,
        pendingLabel: 'Loan Funding',
        completedLabel: 'Loan Funded',
    }, LoanDisbursal: {
        order: 5,
        pendingLabel: 'Loan Disbursal',
        completedLabel: 'Loan Disbursed',
    }
};

interface MilestoneItem {
    order: number;
    pendingLabel: string;
    completedLabel: string;
}

export class LoanApplicationProgress {
    private nextMilestone: MilestoneItem;

    public withNextMilestone(milestone: MilestoneItem): LoanApplicationProgress {
        this.nextMilestone = milestone;
        return this;
    }

    public getLabelForMilestone(progressMilestone: MilestoneItem) {
        const isMilestoneCompleted = progressMilestone.order < this.nextMilestone.order;
        return (this.nextMilestone && isMilestoneCompleted) ?
            progressMilestone.completedLabel : progressMilestone.pendingLabel;
    }

    public getNextMilestoneLabel(): string {
        return this.getLabelForMilestone(this.nextMilestone);
    }
}

@Injectable()
export class LoanApplicationProgressFactory {
    public getUpdatedProgress(currentStage?: LoanApplicationPipelineStage): LoanApplicationProgress {
        switch (currentStage) {
            case LoanApplicationPipelineStage.Sanction:
            case LoanApplicationPipelineStage.PreCreditAssessment:
            case LoanApplicationPipelineStage.DetailedCreditAssessment:
                return new LoanApplicationProgress().withNextMilestone(ProgressMilestones.OfferAcceptance);
            default:
                return new LoanApplicationProgress().withNextMilestone(ProgressMilestones.KycVerification);
        }
    }
}